export class CheckDepositDeadLineHour {
  static checkDeadline(last_updated_hour?: number): boolean {
    const current_time = new Date();
    const current_hour = current_time.getHours();
    return !last_updated_hour || (current_hour >= 13 && last_updated_hour <= 13);
  }
}
